var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, Divider, IconButton, Stack, Typography, List, ListItemText, ListItemAvatar, ListItem, ListItemButton, } from '@mui/material';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';
import { countryInformation as countryInformationApi, typicaStockItem as typicaStockItemApi, offerList as offerListApi, } from '../../api/';
import { useRequest } from '../../hooks/requestHook';
import { MovieIcon, StoryIcon } from '../atoms/Icons';
import IconLink from '../atoms/IconLink';
import ForumButton from '../molecules/ForumButton';
import { useRoaster } from '../../hooks/useRoaster';
import OfferListMaterialFab from '../molecules/OfferListMaterialFab';
import OfferListStoryFab from '../molecules/OfferListStoryFab';
import ProducerImageAvatar from './ProducerImageAvatar';
var getLocale = function (locale) { return (locale === 'ja' ? ja : undefined); };
var getYear = function (offerList) {
    var year = offerList.name.match(/(\d{4}\/\d{2})/);
    if (year)
        return year[0];
    return '';
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  h5 {\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 15px;\n    font-weight: bold;\n  }\n\n  h6 {\n    margin-bottom: 15px;\n    font-weight: bold;\n  }\n\n  table {\n    width: 100%;\n    text-align: center;\n    border-collapse: collapse;\n    margin-bottom: 24px;\n\n    thead th {\n      border-top: 1px solid #666;\n      border-bottom: 2px solid #666;\n    }\n\n    tbody td {\n      border-top: 1px solid #666;\n    }\n\n    th,\n    td {\n      padding: 14px 0;\n      &.seller {\n        width: 25%;\n      }\n\n      &.story,\n      &.material,\n      &.forum {\n        width: 25%;\n\n        & > a {\n          .MuiSvgIcon-root {\n            width: 24px;\n            height: 24px;\n          }\n        }\n      }\n\n      &.period {\n        width: 25%;\n      }\n    }\n  }\n"], ["\n  h5 {\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 15px;\n    font-weight: bold;\n  }\n\n  h6 {\n    margin-bottom: 15px;\n    font-weight: bold;\n  }\n\n  table {\n    width: 100%;\n    text-align: center;\n    border-collapse: collapse;\n    margin-bottom: 24px;\n\n    thead th {\n      border-top: 1px solid #666;\n      border-bottom: 2px solid #666;\n    }\n\n    tbody td {\n      border-top: 1px solid #666;\n    }\n\n    th,\n    td {\n      padding: 14px 0;\n      &.seller {\n        width: 25%;\n      }\n\n      &.story,\n      &.material,\n      &.forum {\n        width: 25%;\n\n        & > a {\n          .MuiSvgIcon-root {\n            width: 24px;\n            height: 24px;\n          }\n        }\n      }\n\n      &.period {\n        width: 25%;\n      }\n    }\n  }\n"])));
var CountryInformationWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 20px 24px;\n\n  h6 {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: #333;\n    display: inline-flex;\n\n    .MuiSvgIcon-root {\n      font-size: 24px;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 20px 24px;\n\n  h6 {\n    margin-bottom: 0;\n  }\n\n  a {\n    color: #333;\n    display: inline-flex;\n\n    .MuiSvgIcon-root {\n      font-size: 24px;\n    }\n  }\n"])));
var GroupeddOfferLists = function (_a) {
    var status = _a.status;
    var t = useTranslation().t;
    var _b = React.useState([]), countryInformations = _b[0], setCountryInformations = _b[1];
    var roaster = useRoaster().roaster;
    var getCountryInformations = useRequest(countryInformationApi.getAll);
    var getTypicaStockItems = useRequest(typicaStockItemApi.getAll);
    var _c = React.useState([]), typicaSelectionOfferLists = _c[0], setTypicaSelectionOfferLists = _c[1];
    var getOfferLists = useRequest(offerListApi.getAll);
    var _d = React.useState({
        preparing: undefined,
        active: undefined,
        expired: undefined,
    }), offerListsByStatus = _d[0], setOfferListsByStatus = _d[1];
    var withTypicaSelection = React.useMemo(function () { return status === 'active'; }, [status]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (offerListsByStatus[status])
                            return [2 /*return*/];
                        return [4 /*yield*/, getOfferLists({
                                q: {
                                    with_status: getOfferListStatuses(status),
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        if (!response)
                            return [2 /*return*/];
                        setOfferListsByStatus(function (oldState) {
                            var _a;
                            return (__assign(__assign({}, oldState), (_a = {}, _a[status] = response.data, _a)));
                        });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [t, status, offerListsByStatus, getOfferLists]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCountryInformations(undefined)];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setCountryInformations(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getCountryInformations]);
    React.useEffect(function () {
        if (!withTypicaSelection || !roaster)
            return;
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, offerListMap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getTypicaStockItems({
                            q: {
                                purchasable: [null, roaster.id],
                                imported: [roaster.id],
                                with_ordered_quantity: true,
                                remaining: true,
                            },
                            per: 1000,
                            page: 1,
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        offerListMap = {};
                        response.data.forEach(function (_a) {
                            var offerList = _a.offer.offerList;
                            offerListMap[offerList.id] = offerList;
                        });
                        setTypicaSelectionOfferLists(Object.values(offerListMap));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [roaster, getTypicaStockItems, withTypicaSelection]);
    var offerLists = React.useMemo(function () { return offerListsByStatus[status] || []; }, [offerListsByStatus, status]);
    var groupedOfferList = offerLists.reduce(function (result, offerList) {
        var year = getYear(offerList);
        var country = offerList.producer.country;
        if (!result[country])
            result[country] = {};
        if (Array.isArray(result[country][year])) {
            result[country][year].push(offerList);
        }
        else {
            result[country][year] = [offerList];
        }
        return result;
    }, {});
    var renderCountryInformation = React.useCallback(function (country) {
        var countryInformation = countryInformations.find(function (info) { return info.country === country; });
        if (!countryInformation)
            return null;
        var storyUrl = countryInformation.storyUrl, movieUrl = countryInformation.movieUrl;
        return (React.createElement(React.Fragment, null,
            storyUrl && (React.createElement(IconButton, null,
                React.createElement(IconLink, { external: true, to: storyUrl, icon: React.createElement(StoryIcon, null), title: t('links.story') }))),
            movieUrl && (React.createElement(IconButton, null,
                React.createElement(IconLink, { external: true, to: movieUrl, icon: React.createElement(MovieIcon, null), title: t('links.movie') })))));
    }, [t, countryInformations]);
    return (React.createElement(Wrapper, null,
        typicaSelectionOfferLists.length === 0 && offerLists.length === 0 && (React.createElement(Box, { sx: { margin: 3 } },
            React.createElement(Typography, null, t('labels.noData')))),
        offerLists.length > 0 &&
            Object.entries(groupedOfferList).map(function (_a) {
                var country = _a[0], offerListsByYear = _a[1];
                return Object.keys(offerListsByYear)
                    .sort(function (a, b) { return b.localeCompare(a); })
                    .map(function (year) { return (React.createElement(React.Fragment, { key: year },
                    React.createElement(CountryInformationWrapper, null,
                        React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.h6; } } }, "".concat(t("countries.".concat(country), { lng: 'en' }), " ").concat(year)),
                        React.createElement(Stack, { direction: "row", spacing: 1, ml: 2 }, renderCountryInformation(country))),
                    React.createElement(Divider, null),
                    React.createElement(OfferListsTable, { offerLists: offerListsByYear[year] }))); });
            }),
        withTypicaSelection && typicaSelectionOfferLists.length > 0 && (React.createElement(Box, null,
            React.createElement(CountryInformationWrapper, null,
                React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.h6; } } }, t('pages.typicaSelection.title'))),
            React.createElement(Divider, null),
            React.createElement(OfferListsTable, { offerLists: typicaSelectionOfferLists, isTypicaSelection: true })))));
};
export default GroupeddOfferLists;
var OfferListsTable = function (_a) {
    var offerLists = _a.offerLists, _b = _a.isTypicaSelection, isTypicaSelection = _b === void 0 ? false : _b;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var renderOrderPageLink = React.useCallback(function (_a) {
        var name = _a.name, country = _a.producer.country;
        if (isTypicaSelection) {
            var countryName = t("countries.".concat(country), { lng: 'en' });
            return (React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.subtitle2; } } },
                countryName,
                " / ",
                name));
        }
        return (React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.subtitle2; } } }, name));
    }, [isTypicaSelection, t]);
    var renderPeriod = React.useCallback(function (_a) {
        var _b;
        var roasterOfficeDetail = _a.roasterOfficeDetail, expiredAt = _a.expiredAt;
        if (isTypicaSelection) {
            return t('pages.typicaSelection.orderPeriod');
        }
        var sampleOrderStartedAt = (_b = roasterOfficeDetail === null || roasterOfficeDetail === void 0 ? void 0 : roasterOfficeDetail.sampleOrderStartedAt) !== null && _b !== void 0 ? _b : '';
        if (sampleOrderStartedAt.length === 0 || expiredAt.length === 0) {
            return t('labels.pending');
        }
        var startDateString = format(new Date(sampleOrderStartedAt), 'yyyy/MM/dd/HH:mm (eee)', {
            locale: getLocale(i18n.language),
        });
        var endDate = new Date(expiredAt);
        endDate.setMinutes(endDate.getMinutes() - 1);
        var endDateString = format(endDate, 'yyyy/MM/dd/HH:mm (eee)', {
            locale: getLocale(i18n.language),
        });
        return "".concat(startDateString, " - ").concat(endDateString);
    }, [t, i18n.language, isTypicaSelection]);
    return (React.createElement(List, { sx: { padding: 0 } }, offerLists.map(function (offerList) { return (React.createElement(ListItem, { key: offerList.id, secondaryAction: React.createElement(ForumButton, { iconOnly: true, offerListId: offerList.id, role: "roaster" }), sx: {
            padding: 0,
        } },
        React.createElement(ListItemButton, { alignItems: "flex-start", href: isTypicaSelection
                ? "/roaster/typica_selection#".concat(offerList.id)
                : "/roaster/offer_lists/".concat(offerList.id), sx: { padding: '16px' } },
            React.createElement(ListItemAvatar, { sx: {
                    mt: '2px',
                    minWidth: {
                        xs: '56px',
                        md: '64px',
                    },
                } },
                React.createElement(ProducerImageAvatar, { offerList: offerList })),
            React.createElement(ListItemText, { primary: renderOrderPageLink(offerList), secondary: React.createElement(React.Fragment, null,
                    React.createElement(Box, { component: "span", mt: 0.5, display: "block" }, renderPeriod(offerList)),
                    React.createElement(Stack, { direction: "row", spacing: 1.5, mt: 1, component: "span" },
                        React.createElement(OfferListMaterialFab, { offerList: offerList, blankValue: "", showTitle: true }),
                        React.createElement(OfferListStoryFab, { offerList: offerList, blankValue: "", showTitle: true }))), sx: { margin: '0 32px 0 0' } })))); })));
};
var getOfferListStatuses = function (status) {
    switch (status) {
        case 'active':
            return ['active'];
        case 'expired':
            return ['expired'];
        case 'preparing':
            return ['preparing', 'prepared'];
        default:
            return [];
    }
};
var templateObject_1, templateObject_2;
